<template>
  <div class="main">
    <Nav />
    <div class="container">
      <div class="content">
        <h1 class="title is-1">About the I-CAN! Team</h1>
        <div class="box">
          <p>
            <strong>John Bartholomew:</strong> Dr. Bartholomew is the Department Chair for the Kinesiology and Health Education program at The University of Texas. He graduated with an A.B. in Psychology cum Laude from Harvard University, where he was a three-year letter winner on the (American) football team. He earned a Ph.D. in Exercise Science from Arizona State University and began his faculty position at The University of Texas in 1996. His research centers on interventions to increase physical activity in schools and examines the impact of that activity on academic performance. He is particularly interested in supporting behavior change by teachers to implement these active lessons.
          </p>
        </div>
        <div class="box">
          <p>
            <strong>Esbelle Jowers:</strong> Dr. Jowers is a faculty member and the director of the Exercise &amp; Sports Psychology Lab at The University of Texas at Austin. She graduated with a Bachelor of Science degree from the College of William &amp; Mary in Virginia. She earned both a Masters degree and a Doctorate in Kinesiology/Exercise Science, with a specialization in Physical Development and Aging, from The University of Texas at Austin. Dr. Jowers is the co-creator of the I-CAN! program and has directed the program activities since 2001.
          </p>
        </div>
        <div class="box">
          <p>
            <strong>Alex Peluso:</strong> Alex is a masters student at UT studying Health Behavior and Health Education. She received her Bachelor of Science from The University of South Carolina in Exercise Science in 2017. Alex has been a member of the Exercise and Sport Psychology Lab at UT for two years and most enjoys connecting with the students during I-CAN! data collection.
          </p>
        </div>

        <div class="box">
          <p>
            <strong>Rupal Patel:</strong> Rupal is a doctoral student at The University of Texas studying Health Behavior and Health Education. Rupal earned her Bachelor of Science in Kinesiology from The University of Texas at Austin in 2003, then went on to earn her Doctorate of Physical Therapy from the University of Miami in 2007. Rupal has been practicing Pilates based physical therapy in Austin since 2010 and is interested in studying the disparities in how individuals experience healthcare. She has been a member of the Exercise and Sports Psychology Lab since Fall 2018.
          </p>
        </div>

        <div class="box">
          <p>
            <strong>Katie Burford:</strong> Katie is a master's student at The University of Texas at Austin studying Exercise Physiology. She received her Bachelor in Science from UT in Public Health. She has been a member of the Exercise and Sport Psychology Lab at UT for over a year. During data collection, you will often find Katie in P.E. classes exploring enjoyment, motivation, and high-intensity interval training. In her spare time she likes to trail run with her poodle Blue, cook with friends, and be in the outdoors.
          </p>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
export default {
  components: {
    Nav,
    Footer
  }
};
</script>

<style lang='scss'>
</style>

